import { useQueryClient } from "@tanstack/react-query"
import { useState } from "react"
import CameraComponent from "../../../components/elements/BaseCameraComponent"
import BaseModal from "../../../components/layout/BaseModal"
import { useAddImgsToTaskMutation } from "../api/services"
import Dropzone from "react-dropzone"
import { ReactComponent as UPLOAD } from "../../../assets/Upload.svg"
import BaseDocElement from "../../../components/elements/BaseDocElement"

type AddImagesModalType = {
    modalId: number
    taskId?: string
    queryKeyOfSession?: string
    handleAddImgs?: () => void
    onDocumentsChange?: (documents: File[]) => void
}

export default function AddImagesModal(props: AddImagesModalType) {
    const queryClient = useQueryClient()
    const { mutate: addImgsToTask } = useAddImgsToTaskMutation(queryClient, props.queryKeyOfSession ?? "")

    // Handle camera upload (existing functionality for taskId)
    const uploadImage = async (imageDataUrl: string[]) => {
        if (!props.taskId) {
            // Convert Data URL to File objects for non-task usage
            const dataUrlsToFiles = (dataUrls: string[]): File[] => {
                return dataUrls.map((dataUrl, index) => {
                    const byteString = atob(dataUrl.split(",")[1])
                    const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0]
                    const arrayBuffer = new ArrayBuffer(byteString.length)
                    const uintArray = new Uint8Array(arrayBuffer)

                    for (let i = 0; i < byteString.length; i++) {
                        uintArray[i] = byteString.charCodeAt(i)
                    }

                    const blob = new Blob([arrayBuffer], { type: mimeString })
                    return new File([blob], `camera-image-${index + 1}.png`, { type: mimeString })
                })
            }

            const newFiles = dataUrlsToFiles(imageDataUrl)
            props.onDocumentsChange?.(newFiles)
            return
        }

        // Original functionality for taskId
        const dataUrlsToBlobs = (dataUrls: string[]): Blob[] => {
            return dataUrls.map((dataUrl) => {
                const byteString = atob(dataUrl.split(",")[1])
                const mimeString = dataUrl.split(",")[0].split(":")[1].split(";")[0]
                const arrayBuffer = new ArrayBuffer(byteString.length)
                const uintArray = new Uint8Array(arrayBuffer)

                for (let i = 0; i < byteString.length; i++) {
                    uintArray[i] = byteString.charCodeAt(i)
                }

                return new Blob([arrayBuffer], { type: mimeString })
            })
        }

        const blobs = dataUrlsToBlobs(imageDataUrl)
        const formData = new FormData()

        blobs.forEach((blob: any) => {
            if (blob) {
                formData.append("documents", blob)
            }
        })

        addImgsToTask({ id: props.taskId, formData: formData })
        props.handleAddImgs?.()
    }

    return (
        <BaseModal big title={"Bilder hinzufügen"} modalId={props.modalId}>
            <CameraComponent upload={uploadImage} />
        </BaseModal>
    )
}
